import { ValidationErrors, ValidatorFn, FormGroup } from "@angular/forms";

export function medicineAllergyValidator(control: FormGroup): ValidationErrors | null {
    const hasAllergies = control.value.hasAllergiesToMedicines;
    const medicines = control.value.allergiesCauseMedicine;
    return hasAllergies && !medicines ? { "medicineMissing": true } : null;
}